import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Button, Stack } from '@chakra-ui/react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import { useVoidEnvelope } from '~/core/shared/api/signature';
import {
  Dialog,
  DialogProps,
  FormField,
  Input,
} from '~/core/shared/components';
import { useFormResolver } from '~/core/shared/hooks';
import { Envelope } from '~/core/shared/types';

type VoidModalProps = Omit<DialogProps, 'children'> & {
  envelope: Envelope;
  modalApi: UseOpenCloseReturn;
};
type FormValues = {
  reason: string;
};
const validationSchema = yup.object({
  reason: yup.string().trim().required(),
});

export const ApplicationEnvelopesVoidModal = ({
  envelope,
  modalApi,
  ...props
}: VoidModalProps) => {
  const { voidEnvelope } = useVoidEnvelope();
  const resolver = useFormResolver<FormValues>(validationSchema);
  const form = useForm<FormValues>({ resolver });

  const onSubmit = async (data: FormValues) => {
    try {
      await voidEnvelope({ envelopeId: envelope.id, data });
      modalApi.onClose();
    } catch {
      // error handled by hook
    }
  };

  return (
    <Dialog
      header={`Void "${envelope.name}"`}
      size="lg"
      {...props}
      onOpenChange={modalApi.onOpenChange}
      open={modalApi.open}
    >
      <Stack gap={8}>
        <FormProvider {...form}>
          <Stack as="form" gap={4} onSubmit={form.handleSubmit(onSubmit)}>
            <FormField
              component={Input}
              label="Reason"
              name="reason"
              required
            />
            <Button colorPalette="primary" type="submit" variant="solid">
              Void
            </Button>
          </Stack>
        </FormProvider>
      </Stack>
    </Dialog>
  );
};
